import { render, staticRenderFns } from "./PriceCategories.vue?vue&type=template&id=7ff93805&"
import script from "./PriceCategories.vue?vue&type=script&lang=ts&"
export * from "./PriceCategories.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports